import { useQuery } from '@tanstack/react-query';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export type ApiRequest_GetAll_Community = Record<string, never>;

export type ApiResponse_GetAll_Community = Array<{
  id: number;
  name: string;
  description: string;
  rules?: string;
  require_verification: boolean;
  created_by: string;
  created_at: string;
  updated_at: string;
  is_active: boolean;
  metadata?: Record<string, unknown>;
  member_count: number;
  user_role: 'ADMIN' | 'MEMBER' | null;
  user_status: 'ACTIVE' | 'INACTIVE' | 'BANNED' | null;
}>;

const METHOD = 'GET';
const ENDPOINT = 'communities';
export const QUERY_KEY = (params?: ApiRequest_GetAll_Community) =>
  getQueryKey(METHOD, ENDPOINT, params);

export const useGetCommunities = (
  params?: ApiRequest_GetAll_Community,
  enabled = true
) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token,
    queryKey: QUERY_KEY(params),
    queryFn: async () => {
      const data = await handleApiCall<
        ApiResponse_GetAll_Community,
        ApiRequest_GetAll_Community
      >(session, METHOD, getResolvedEndpoint(ENDPOINT, {}), params);

      return data;
    },
  });
};